import React from 'react';

/**
 * 固定免责声明。
 *
 * 文案要短到一行放得下（14px 字号下不超过约 20 个字），所以：
 *   - 不写「⚠️」：外层 .ai-disclaimer 本身就是浅黄警示条，图标属于重复提示
 *   - 「识别与核对结果」压成「识别与核对」：后面的「仅供参考」已经限定了范围
 *   - 「药品说明书」压成「说明书」：这个页面里出现的说明书只可能是药品的
 *
 * 口径说明（别改回「AI」）：本项目的识别与核对由三部分组成 ——
 *   1. 拍照 OCR：浏览器端 Tesseract.js / 服务端 OCR，属于机器学习模型；
 *   2. 语音转文字：浏览器自带的 Web Speech API，属于语音识别模型；
 *   3. 药品剂量核对：**规则引擎**（正则 + 人工整理的参考库），没有模型参与。
 * 第 3 项如果把话说成「AI 判定」，就是把查表包装成智能结论，
 * 所以统一用「识别与核对」这个中性说法。
 */
export default function AIDisclaimer() {
  return (
    <div className="ai-disclaimer">
      识别与核对仅供参考，请以说明书为准
    </div>
  );
}